/**
 * Cart GWP
 * @param {boolean} initLoad when 'DOMContentLoaded'
 * @param {number} variantId when 'product:changed'
 */
function cartGWP(initLoad, variantId) {
  const c = {
    dom: {
      giftWrapper: 'cartGwp',
      giftCartText: 'js-auto-add-text',
    },
    url: {
      cart: '/cart.js',
      change: '/cart/change.js',
    },
    cls: {
      visible: 'is-visible',
    },
  };

  let giftData;
  let defaultText;
  let threshold;
  let adjustedCartTotal;
  let adjustedCartQty;
  let giftInCart;
  let giftInCartQty;
  let product;
  let variant;
  let available;
  let limitQty;
  let excludeGiftCards;
  let eligibleIntl;

  /**
   * init
   */
  function init() {
    const $giftWrapper = document.getElementById(c.dom.giftWrapper);
    giftData = SDG.Data.gwp;
    if (!giftData || !$giftWrapper) return;

    ({ threshold,
      product,
      defaultText,
      giftVariant,
      limitQty,
      matchTypes,
      excludeGiftCards,
      eligibleIntl
    } = giftData);

    variant = giftVariant
      ? product.variants.find(item => item.id === Number(giftVariant))
      : product.variants.find(item => item.available);
    available = variant ? variant.available : false;

    if (variantId) {
      const variantIdNum = variantId.includes(':')
        ? Number(variantId.split(':')[0])
        : Number(variantId);

      // gwp product was removed
      if (variant && variantIdNum === variant.id) return;
    }

    getCart();
    if (initLoad) addEvents();
  }

  /**
   * add events
   */
  function addEvents() {
    document.addEventListener('product:added', (resp) => {
      if (resp.detail.variant === variant.id) return;
      getCart();
    });
  }

  /**
   * get cart data
   */
  function getCart() {
    _.ajax({
      type: 'GET',
      url: c.url.cart,
      success: onSuccess,
      error: onError,
    });
  }

  /**
   * on error
   */
  function onError() {
    console.warn('Bag refresh error with ajax request.');
  }

  /**
   * on success
   * @param {Object} res ajax response
   */
  function onSuccess(res) {
    // disable for international users using Flow
    if (!eligibleIntl && checkFlow()) return;
    // disable for Loop Returns Shop Now exchanges
    var chkbody = document.querySelector('body');
    if (chkbody.classList.contains('loop-returns-activated')) {
      return;
    }
    gwpCheck(res);
  }

  /**
   * check flow
   */
  function checkFlow() {
    return false; // No longer using Flow
  }

  /**
   * gwp check
   * @param {Object} cart custom cart object
   */
  function gwpCheck(cart) {
    giftInCart = cart.items.find((item) => item.properties.promo === 'giveaway');
    giftInCartQty = giftInCart ? giftInCart.quantity : 0;
    updateAdjustedTotal(cart);
  }

  /**
   * update adjusted total
   * @param {Object} cart custom cart object
   */
  function updateAdjustedTotal(cart) {
    const matchTypesArr = matchTypes && matchTypes !== ''
      ? matchTypes.toLowerCase().split(',').map(i => i.trim())
      : [];

    // Updating adjusted total
    adjustedCartTotal = cart.total_price;
    adjustedCartQty = cart.item_count;
    cart.items.forEach((item) => {
      if (
        item.properties.promo
        || (excludeGiftCards && item.gift_card)
        || (matchTypes && !matchTypesArr.includes(item.product_type.toLowerCase()))
      ) {
        adjustedCartTotal -= item.line_price;
        adjustedCartQty -= item.quantity;
      }
    });

    // Updating cart messaging
    if (defaultText && (giftInCartQty > 0 || adjustedCartTotal >= threshold)) {
      const $giftCartText = document.querySelector(`.${c.dom.giftCartText}`);
      _.removeClass($giftCartText, c.cls.visible);

    } else if (adjustedCartTotal < threshold && available) {
      setTimeout(() => {
        const $giftCartText = document.querySelector(`.${c.dom.giftCartText}`);
        if (!$giftCartText) return;
        const priceRemaining = threshold - adjustedCartTotal;
        if (defaultText) _.addClass($giftCartText, c.cls.visible);
        $giftCartText.textContent = defaultText
          ? defaultText.replace('remaining_amount', _.formatPriceDisplay(priceRemaining))
          : '';
      }, 500); // timeout for cart render
    }

    const limitQtyUpdate = (
      adjustedCartTotal >= threshold
      && available
      && giftInCartQty === 0
      && adjustedCartQty > 0
    );

    const unlimitedQtyUpdate = (
      adjustedCartTotal >= threshold
      && available
      && adjustedCartQty > 0
      && adjustedCartQty !== giftInCartQty
    );

    const shouldUpdate = (
      (limitQty && limitQtyUpdate)
      || (!limitQty && unlimitedQtyUpdate)
    );

    const shouldRemove = (
      (adjustedCartTotal < threshold
      || adjustedCartQty === 0)
      && giftInCartQty > 0
    );

    // Updating GWP in cart
    if (shouldUpdate) {
      updateCart();
    } else if (shouldRemove) {
      updateCart(true);
    }
  }

  /**
   * update cart
   * @param {Boolean} remove remove gift instead of add
   */
  function updateCart(remove) {

    if (remove) { // remove GWP
      _.ajax({
        url: '/cart/change.js',
        type: 'POST',
        contentType: 'application/json',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        data: { id: variant.id, quantity: 0 },
        success: (res) => {
          document.dispatchEvent(
            new CustomEvent('product:changed', {
              bubbles: true,
              detail: {
                variant: variant,
                quantity: 0,
              },
            })
          );

          // refresh user's window as there's no reliable cart rerender fn
          setTimeout(() => {
            window.location.reload();
          }, 500);
        }
      });
    } else { // add or update GWP
      const gwpQty = !limitQty ? adjustedCartQty : 1;
      const data = {
        quantity: gwpQty,
        id: variant.id
      };

      if (!limitQty && giftInCartQty > 0) {
        _.ajax({
          url: '/cart/change.js',
          type: 'POST',
          contentType: 'application/json',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
          data,
          success: (res) => {
            document.dispatchEvent(
              new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                  properties: res.properties,
                  product_id: res.product_id,
                  variant: res.id,
                  quantity: res.quantity,
                },
              })
            );
          },
        });

      } else { // if (limitQty || giftInCartQty === 1)
        data.properties = {
          promo: 'giveaway',
        }

        _.ajax({
          url: '/cart/add.js',
          type: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(data),
          success: (res) => {
            document.dispatchEvent(
              new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                  properties: res.properties,
                  product_id: res.product_id,
                  variant: res.id,
                  quantity: res.quantity,
                },
              })
            );
          },
        });
      }
    }
  }

  return init();
}
